/* eslint-disable max-len */
import { getMessage } from '../../translations';
import { getUserFromLocalStorage } from '../../component/utils/user';
const userLang = getUserFromLocalStorage();
const langulanguageCodeage = userLang?.language?.toLowerCase().startsWith('en') ? 'en' : userLang?.language?.toLowerCase() || 'default-language';

export const getFreightsImporterSetting = ({
  portLoadingDropdownData,
  portDestinationDropdownData,
  incoTermDropdownData,
  qualityGroupDropdownData,
  currenciesDropdownData,
  currenciesAbbrDropdownData,
  shippingLinesDropdownData,
  volumeUnitDropdownData,
}) => ({
  //multipleFileUpload: true,
  developerMode: false,
  identifier: 'freights',
  language: languageCode,
  allowManualInput: true,
  inputTypes:["csv", "tsv", "xls", "xlsx","pdf"],
  i18nOverrides: {
    txt_back_page_dialog: getMessage("If you press the \"Go back\" button, you will lose the progress of the current step."),
    txt_close_page_modal: getMessage("If you press the \"Go back\" button, you will lose the entire progress of all steps."),
    txt_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error won't be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_confirm_submit_data_without_error: getMessage("Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_allow_error_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_import_data_error_exceed: getMessage("Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button."),
  },
  columns: [
    {
      key: 'portOfLoading',
      label: getMessage('Port of loading'),
      description: getMessage('Port of loading'),
      columnType: 'category',
      dropdownOptions: portLoadingDropdownData,
      alternativeMatches: ['POL', 'Loading', 'Loading port'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Port of loading shouldn't be blank"),
        },
      ],
      isMultiSelect: false,
    },

    {
      key: 'portOfDestination',
      label: getMessage('Port of destination'),
      description: getMessage('Port of destination'),
      columnType: 'category',
      dropdownOptions: portDestinationDropdownData,
      alternativeMatches: [
        'Destination port',
        'Destination country',
        'Country of destination',
      ],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Port of desintation shouldn't be blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'shippingLine',
      label: getMessage('Shipping line'),
      description: getMessage('Shipping line'),
      example: ' SEALAND',
      columnType: 'category',
      dropdownOptions: shippingLinesDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Shipping line shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'qualityGroup',
      label: getMessage('Material group'),
      description: getMessage('Material group'),
      example: 'Ferrous',
      columnType: 'category',
      dropdownOptions: qualityGroupDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Material group shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'cost',
      label: getMessage('Cost'),
      description: getMessage('Freight cost'),
      example: '450.00',
      columnType: 'float',
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Freight cost shouldn't be left blank"),
        },
      ],
    },
    {
      key: 'costCurrency',
      label: getMessage('Cost currency'),
      description: getMessage('Freight cost currency code'),
      example: 'USD',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      isMultiSelect: false,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Freight cost currency code"),
        },
      ],
    },
    {
      key: 'logisticForwarder',
      label: getMessage('Logistic forwarder'),
      description: getMessage('Logistic forwarder'),
      example: 'GASTOS MARITIMOS',
      columnType: 'string',
    },
    {
      key: 'logisticMaterial',
      label: getMessage('Logistic material'),
      description: getMessage('Logistic material'),
      example: '40HC or 20HC',
      columnType: 'string',      
    },
    {
      key: 'incoterm',
      label: getMessage('Incoterm'),
      description: getMessage('incoterm'),
      example: 'CIF',
      columnType: 'category',
      dropdownOptions: incoTermDropdownData,
      isMultiSelect: false,
    },
    {
      key: 'comment',
      label: getMessage('Comment'),
      description: getMessage('Comment on freight'),
      example: '14 Dias / THCD INCL',
      columnType: 'string',
    },
    {
      key: 'lastValidityDate',
      label: getMessage('Last validity date'),
      description: getMessage('Last validity date'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      outputFormat: 'YYYY-MM-DD',
    },
    {
      key: 'firstValidityDate',
      label: getMessage('First validity date'),
      description: getMessage('First validity date'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      outputFormat: 'YYYY-MM-DD',
    },
    {
      key: 'costVolume',
      label: getMessage('Cost volume'),
      description: getMessage('Cost volume'),
      example: 'CTN',
      columnType: 'category',
      dropdownOptions: volumeUnitDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Cost volume shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'blCost',
      label: getMessage('BL cost'),
      description: getMessage('BL cost value'),
      example: '50.00',
      columnType: 'float',
    },
    {
      key: 'blCurrency',
      label: getMessage('BL currency'),
      description: getMessage('Currency code of BL cost'),
      example: '$',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      isMultiSelect: false,
    },
    {
      key: 'thcAdminCost',
      label: getMessage('Other cost'),
      description: getMessage('Miscellaneous cost'),
      example: '25.00',
      columnType: 'float',
    },
    {
      key: 'thcAdminCostCurrency',
      label: getMessage('Other cost currency'),
      description: getMessage('Currency code of THC admin cost'),
      example: '$',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      isMultiSelect: false,
    },
    {
      key: 'thcAdminCostVolume',
      label: getMessage('Other cost volume'),
      description: getMessage('Other cost volume'),
      example: 'CTN',
      columnType: 'category',
      dropdownOptions: volumeUnitDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Other cost volume shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'customsCost',
      label: getMessage('Customs cost'),
      description: getMessage('Customs cost'),
      example: '25.00',
      columnType: 'float',
    },
    {
      key: 'customsCurrency',
      label: getMessage('Customs currency'),
      description: getMessage('Currency code of custom cost'),
      example: '$',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      isMultiSelect: false,
    },
    {
      key: 'volumicCustomsCost',
      label: getMessage('Volumic customs cost'),
      description: getMessage('Volumic customs cost'),
      example: '25.00',
      columnType: 'float',
    },
    {
      key: 'volumicCustomsCurrency',
      label: getMessage('Volumic customs currency'),
      description: getMessage('Currency code of volumic customs'),
      example: '$',
      columnType: 'category',
      dropdownOptions: currenciesAbbrDropdownData,
      isMultiSelect: false,
    },
    {
      key: 'volumicCustomsVolume',
      label: getMessage('Volumic customs volume'),
      description: getMessage('Volumic customs volume'),
      example: 'CTN',
      columnType: 'category',
      dropdownOptions: volumeUnitDropdownData,
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage("Volumic customs volume shouldn't be left blank"),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'demurrage',
      label: getMessage('Demurrage in days'),
      description: getMessage('Demurrage in days'),
      example: '25.00',
      columnType: 'float',
    },
    {
      key: 'detention',
      label: getMessage('Detention in days'),
      description: getMessage('Detention in days'),
      example: '25.00',
      columnType: 'float',
    },
    // {
    //   key: 'lane',
    //   label: getMessage('Lane'),
    //   description: getMessage('Lane'),
    //   example: 'lane',
    //   columnType: 'string',
    // },
  ],
});
